<template>
  <div class="row">
    <div class="col">
      <h2 class="titre">Consultation Journal</h2>
    </div>
  </div>
  <div class="container p-0 my-3 border">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-3 lbl">
            <label>No. Cardex :</label>
          </div>
          <div class="col txt">
            <p v-if="!numeroCardex"> ... </p>
            <p v-else> {{ numeroCardex }} </p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col-3 lbl">
            <label>Site d'origine :</label>
          </div>
          <div class="col txt">
            <p v-if="!siteAfficher"> ... </p>
            <p v-else> {{ siteAfficher }} </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="row">
          <div class="col-3 lbl">
            <label>Intervenant :</label>
          </div>
          <div class="col txt">
            <p v-if="!intervenantAfficher"> ... </p>
            <p v-else> {{ intervenantAfficher }} </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="row">
          <div class="col-3 lbl">
            <label>Genre :</label>
          </div>
          <div class="col-4 left">
            <div v-for="gr of genres" :key="gr.key">
              <RadioButton :inputId="gr.key" name="gr" :value="gr.name" v-model="genreAfficherChoix" :disabled="true"/>
              <label class="lbl ml5 pt5" :for="gr.key">{{ gr.name }}</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3 lbl">
            <label>Nature :</label>
          </div>
          <div class="col txt">
            <p v-if="!natureAfficher"> ... </p>
            <p v-else> {{ natureAfficher }} </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container p-0 my-3 border">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-4 lbl">
            <label>Type :</label>
          </div>
          <div class="col txt">
            <p v-if="!typeAfficher"> ... </p>
            <p v-else> {{ typeAfficher }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 lbl">
            <label>Catégorie :</label>
          </div>
          <div class="col txt">
            <p v-if="!categorieAfficher"> ... </p>
            <p v-else> {{ categorieAfficher }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 lbl">
            <label>Endroit :</label>
          </div>
          <div class="col txt">
            <p v-if="!endroitAfficher"> ... </p>
            <p v-else> {{ endroitAfficher }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 lbl">
            <label>Origine :</label>
          </div>
          <div class="col txt">
            <p v-if="!origineAfficher"> ... </p>
            <p v-else> {{ origineAfficher }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 lbl">
            <label>Reference vidéo :</label>
          </div>
          <div class="col txt">
            <p v-if="!referenceVideo"> ... </p>
            <p v-else> {{ referenceVideo }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 lbl">
            <label>Descriptif :</label>
          </div>
          <div class="col txt">
            <p v-if="!descriptif"> ... </p>
            <p v-else> {{ descriptif }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 lbl">
            <label>Survenu le :</label>
          </div>
          <div class="col txt">
            <p v-if="!survenuLe"> ... </p>
            <p v-else> {{ survenuLe }} </p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col-4 lbl">
            <label>No de dossier :</label>
          </div>
          <div class="col txt">
            <p v-if="!numeroDossier"> ... </p>
            <p v-else> {{ numeroDossier }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 lbl">
            <label>Référence 1 :</label>
          </div>
          <div class="col txt">
            <p v-if="!reference1"> ... </p>
            <p v-else> {{ reference1 }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 lbl">
            <label>Référence 2 :</label>
          </div>
          <div class="col txt">
            <p v-if="!reference2"> ... </p>
            <p v-else> {{ reference2 }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 lbl">
            <label>Référence 3 :</label>
          </div>
          <div class="col txt">
            <p v-if="!reference3"> ... </p>
            <p v-else> {{ reference3 }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 lbl">
            <label>Localisation :</label>
          </div>
          <div class="col txt">
            <p v-if="!localisationAfficher"> ... </p>
            <p v-else> {{ localisationAfficher }} </p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 lbl">
            <label>Temps consacré :</label>
          </div>
          <div class="col txt">
            <p v-if="!temps"> ... (total en minutes)</p>
            <p v-else> {{ temps }} (total en minutes)</p>
          </div>
        </div>
        <div class="row">
          <div class="col-4 lbl">
            <label>Date de fin :</label>
          </div>
          <div class="col txt">
            <p v-if="!finDate"> ... </p>
            <p v-else> {{ finDate }} </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-2 lbl">Commentaire :</div>
    </div>
    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-lg-11">
        <TextArea class="consulter-journal-commentaire" :value="commentaire" rows="10" disabled/>
      </div>
    </div>
  </div>
  <ButtonBar :modifierButton="modifierButton"
             @fermer="fermer" @modifier="modifier"/>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import ButtonBar from '../../../components/dossier/Consulter/ButtonBarJournal.vue'

export default {
  name: "ConsulterJournal",
  components: {
    ButtonBar
  },
  mounted() {
    this.isDataLoading = true;

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Consulter Journal");
    this.getJournal();
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      actionAccesDecision: "dossier/actionAccesDecision"
    })
  },
  data() {
    return {
      isDataLoading: false,
      modifierButton: false,
      isApprouvable: false,
      isDoInactif: false,
      numeroCardex: null,
      genres: [
        {name: 'Surveillance', key: 'Sur'},
        {name: 'Sécurité', key: 'Sec'}
      ],
      genreAfficher: null,
      natureAfficher: null,
      typeAfficher: null,
      categorieAfficher: null,
      numeroDossier: null,
      intervenant: null,
      intervenantAfficher: null,
      siteAfficher: null,
      survenuLe: null,
      finDate: null,
      descriptif: null,
      referenceVideo: null,
      reference1: null,
      reference2: null,
      reference3: null,
      origineAfficher: null,
      endroitAfficher: null,
      localisationAfficher: null,
      temps: null,
      commentaire: null,
      genreAfficherChoix: null,
      creerParDescription: null,
    };
  },
  methods: {
    assignerJournal(res) {
      this.numeroCardex = res.data.entite.dossierVO.numeroCardex;
      this.siteAfficher = res.data.entite.dossierVO.siteAfficher;
      this.intervenant = res.data.entite.dossierVO.principaleIntervenant;
      this.intervenantAfficher = res.data.entite.dossierVO.intervenantAfficher;
      this.genreAfficher = res.data.entite.dossierVO.genreAfficher;
      if (this.genreAfficher == 'Sécurité') {
        this.genreAfficherChoix = 'Sécurité';
      }
      if (this.genreAfficher == 'Surveillance') {
        this.genreAfficherChoix = 'Surveillance';
      }
      this.natureAfficher = res.data.entite.dossierVO.natureAfficher;
      this.typeAfficher = res.data.entite.dossierVO.typeAfficher;
      this.categorieAfficher = res.data.entite.dossierVO.categorieAfficher;
      this.numeroDossier = res.data.entite.dossierVO.numeroDossier;
      this.reference1 = res.data.entite.dossierVO.reference1;
      this.reference2 = res.data.entite.dossierVO.reference2;
      this.reference3 = res.data.entite.dossierVO.reference3;
      this.descriptif = res.data.entite.dossierVO.descriptif;
      this.referenceVideo = res.data.entite.dossierVO.sequentielNumero;
      this.localisationAfficher = res.data.entite.dossierVO.localisationAfficher;
      this.origineAfficher = res.data.entite.dossierVO.origineAfficher;
      this.endroitAfficher = res.data.entite.dossierVO.endroitAfficher;
      this.survenuLe = this.$commun.formatDateHeure(res.data.entite.dossierVO.debutDate);
      this.finDate = this.$commun.formatDateHeure(res.data.entite.dossierVO.finDate);
      this.temps = res.data.entite.narrationVO.temps;
      this.commentaire = res.data.entite.narrationVO.texteSansHTML;
      this.creerParDescription = res.data.entite.dossierVO.creerParDescription;
      this.isDoInactif = res.data.entite.dossierVO.statut === 561
      this.isApprouvable = res.data.entite.narrationVO.approuvable && !this.isDoInactif;
      this.modifierButton = res.data.entite.modifiable;
    },
    getJournal() {
      this.$store
          .dispatch("journal/consulterJournalAction", {
            cle: this.$route.params.cle,
            site: this.$route.params.site
          })
          .then((res) => {
            this.assignerJournal(res);
            this.isDataLoading = false;
          });
    },
    modifier() {
      this.$router.push({
        name: "modifierJournal",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site
        },
      });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  },
}
</script>
